/* THE HEARTS (snippets/swrfm-fav.liquid, 2026-10-06). Every [data-swr-fav] button on the page —
   product cards, the product page, the cart lines in the drawer and on the cart page — shows
   whether that product is on the signed-in customer's grocery list, and toggles it. ("Grocery list"
   is the customer's word since 2026-10-15; it was "favorites" — the data keeps that name.)

   The list lives on the Shopify customer (app metafield `favorites`), the same one the account's
   Grocery list page shows; it is read and written through the store's app proxy, which tells the
   app who is signed in (window.SWRFM_FAV.signedIn comes from Liquid's `customer`). Signed out, a
   tap goes to sign in and comes back. Buttons the cart redraws later are marked as they appear. */
(function () {
  var cfg = window.SWRFM_FAV || {};
  var url = cfg.proxy || '/apps/swrfm/favorites';
  var favs = null; // Set of product GIDs, once read
  var gid = function (id) { return 'gid://shopify/Product/' + id; };

  function mark(root) {
    if (!favs) return;
    (root || document).querySelectorAll('[data-swr-fav]').forEach(function (b) {
      var on = favs.has(gid(b.getAttribute('data-swr-fav')));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      b.title = on ? 'On your grocery list — tap to remove' : 'Add to your grocery list';
    });
  }

  function load() {
    if (!cfg.signedIn) return;
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.favorites) { favs = new Set(d.favorites); mark(); } })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-swr-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (!cfg.signedIn) {
      window.location.href = (cfg.login || '/account/login') + '?return_url=' + encodeURIComponent(location.pathname + location.search);
      return;
    }
    if (!favs) favs = new Set();
    var id = b.getAttribute('data-swr-fav');
    var on = !favs.has(gid(id));
    // Optimistic: the heart fills at once; a failed save puts it back.
    if (on) favs.add(gid(id)); else favs.delete(gid(id));
    mark();
    b.disabled = true;
    fetch(url + '?product=' + encodeURIComponent(id) + '&on=' + (on ? '1' : '0'), { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { favs = new Set(d.favorites || []); mark(); })
      .catch(function () { if (on) favs.delete(gid(id)); else favs.add(gid(id)); mark(); })
      .then(function () { b.disabled = false; });
  }, true);

  // The cart drawer and page redraw their lines; product grids load more cards. Mark new hearts.
  new MutationObserver(function (list) {
    if (!favs) return;
    for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { mark(); return; }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
